import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import RouteAuth from "./utils/RouteAuth";
import Loader from "./components/Loader/Loader";
import { Toaster } from "sonner";
import { useStockEvents } from "./hooks/useStockEvents";

const HomePage = lazy(() => import("./pages/HomePage/HomePage"));
const AccountPages = lazy(() => import("./pages/AccountPages/AccountPages"));
const BranchPages = lazy(() => import("./pages/BranchPages/BranchPages"));
const CategoryPages = lazy(() => import("./pages/CategoryPages/CategoryPages"));
const OrderPages = lazy(() => import("./pages/OrderPages/OrderPages"));
const ProductPages = lazy(() => import("./pages/ProductPages/ProductPages"));
const ShopPage = lazy(() => import("./pages/ShopPage/ShopPage"));
const AnalyticsPage = lazy(() => import("./pages/AnalyticsPage/AnalyticsPage"));
const CartPage = lazy(() => import("./pages/OrderPages/CartPage/CartPage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage/SettingsPage"));

const App = () => {
  useStockEvents();

  return (
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        <Header />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/cart"
            element={
              <RouteAuth role="user">
                <CartPage />
              </RouteAuth>
            }
          />
          <Route
            path="/shop"
            element={
              <RouteAuth role="user">
                <ShopPage />
              </RouteAuth>
            }
          />
          <Route
            path="/analytics"
            element={
              <RouteAuth role="admin">
                <AnalyticsPage />
              </RouteAuth>
            }
          />
          <Route
            path="/settings"
            element={
              <RouteAuth role="admin">
                <SettingsPage />
              </RouteAuth>
            }
          />
          <Route path="/account/*" element={<AccountPages />} />
          <Route path="/branches/*" element={<BranchPages />} />
          <Route path="/categories/*" element={<CategoryPages />} />
          <Route path="/orders/*" element={<OrderPages />} />
          <Route path="/products/*" element={<ProductPages />} />
        </Routes>

        <Footer />
      </BrowserRouter>
      <Toaster
        position="top-center"
        closeButton
        mobileOffset={40}
        offset={90}
        toastOptions={{
          duration: 4000,
          style: {
            padding: "12px 16px",
            borderRadius: "8px",
            fontSize: "14px",
          },
          classNames: {
            success: "!bg-teal-50 !text-teal-700 !border-teal-200",
            error: "!bg-red-50 !text-red-700 !border-red-200",
            warning: "!bg-yellow-50 !text-yellow-700 !border-yellow-200",
            info: "!bg-blue-50 !text-blue-700 !border-blue-200",
          },
        }}
      />
    </Suspense>
  );
};

export default App;
